import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const KeyIndicatorTile: FC = () => (
  <div className="border rounded-lg p-4 flex flex-col gap-3">
    <div className="flex items-center gap-2">
      <SkeletonLoader.Text className="h-4 w-32" />
      <SkeletonLoader.Circle className="h-4 w-4" />
    </div>
    <SkeletonLoader.Text className="h-3 w-20" />
    <SkeletonLoader className="h-8 w-28 rounded" />
    <div className="flex items-center gap-2">
      <SkeletonLoader.Text className="h-3 w-16" />
      <SkeletonLoader className="h-5 w-12 rounded" />
    </div>
    <SkeletonLoader className="h-10 w-full rounded" />
  </div>
);

const ScheduledEventRow: FC = () => (
  <div className="flex items-center gap-3 py-2">
    <div className="flex flex-col items-center gap-1 w-10 shrink-0">
      <SkeletonLoader.Text className="h-3 w-8" />
      <SkeletonLoader.Text className="h-5 w-6" />
    </div>
    <div className="flex flex-col gap-1.5 flex-1 min-w-0">
      <SkeletonLoader.Text className="h-4 w-40" />
      <SkeletonLoader.Text className="h-3 w-24" />
    </div>
    <SkeletonLoader.Circle className="h-6 w-6 shrink-0" />
  </div>
);

const ActionRequiredCard: FC = () => (
  <div className="border rounded-lg p-3 flex flex-col gap-2 w-56 shrink-0">
    <SkeletonLoader.Text className="h-4 w-32" />
    <SkeletonLoader.Text className="h-3 w-24" />
    <SkeletonLoader className="h-6 w-20 rounded" />
  </div>
);

const ActionRequiredSection: FC = () => (
  <div className="flex flex-col gap-2">
    <SkeletonLoader.Text className="h-4 w-48" />
    <div className="flex gap-3 overflow-hidden">
      <ActionRequiredCard />
      <ActionRequiredCard />
      <ActionRequiredCard />
      <ActionRequiredCard />
    </div>
  </div>
);

const LegacyDashboardPageSkeleton: FC = () => (
  <div className="flex w-full flex-col p-4">
    <div className="mx-4 mb-4 flex items-center justify-end gap-3">
      <SkeletonLoader.Text className="h-4 w-40" />
      <SkeletonLoader className="h-8 w-36 rounded-lg" />
    </div>

    <div className="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
      <div className="md:col-span-3 grid grid-cols-1 gap-4 md:grid-cols-3">
        <KeyIndicatorTile />
        <KeyIndicatorTile />
        <KeyIndicatorTile />
      </div>

      <div className="md:col-span-1 border rounded-lg p-4 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <SkeletonLoader.Text className="h-5 w-40" />
          <SkeletonLoader className="h-6 w-20 rounded" />
        </div>
        <div className="flex flex-col divide-y">
          {Array.from({ length: 8 }).map((_, i) => (
            <ScheduledEventRow key={i} />
          ))}
        </div>
      </div>

      <div className="md:col-span-2 border rounded-lg p-4 flex flex-col gap-6">
        <ActionRequiredSection />
        <ActionRequiredSection />
        <ActionRequiredSection />
        <ActionRequiredSection />
      </div>
    </div>
  </div>
);

export default LegacyDashboardPageSkeleton;
